'use strict';

function cleanComment(data, item, list) {
    list.remove(item);
}

module.exports = cleanComment;
